import { h, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Panel from 'utils/panel';
import Icon from 'utils/icon';
import { useProduct } from './product-context';

import './product-size-guide.css';

const ProductSizeGuide = () => {
  const [panelTriggers, setPanelTriggers] = useState({});
  const { sizeGuides: { handle, bodyHtml, ctaText } } = useProduct();

  useEffect(() => {
    const findElements = setTimeout(() => {
      if (!handle || !bodyHtml) return;

      setPanelTriggers(() => ({
        openTriggerEl: 'data-size-guide-trigger',
        closeTriggerEl: 'data-size-guide-close',
      }));
    }, 1000);
    return () => clearTimeout(findElements);
  }, [handle, bodyHtml]);

  useEffect(() => {
    if (!handle || !bodyHtml) return;
    document.querySelector('[ data-size-guide-content]').innerHTML = bodyHtml;
  }, [handle, bodyHtml]);

  return handle && bodyHtml ? (
    <Panel triggers={panelTriggers} isProductSizeGuide={true}>
      <div className="product-size-guide relative pt-[104px] px-5 pb-5 lg:pt-[94px] lg:px-[30px] space-y-5">
        <div
          data-size-guide-close
          className="cursor-pointer h-[44px] w-[44px] max-w-max absolute top-5 right-5"
        >
          <Icon id="close" className="text-tan-100 pointer-events-none" />
        </div>
        <div data-size-guide-content className="overflow-auto"></div>
        <a
          className="button border-transparent mt-[15px] button--secondary bg-tan-100 hover:bg-tan-200 text-s10-m lg:text-s10-d"
          href={`/pages/${handle}`}
        >
          {ctaText}
        </a>
      </div>
    </Panel>
  ) : null;
};

export default ProductSizeGuide;
